import { injectCss } from "../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.cui-html-notice__content{overflow-wrap:break-word;flex:100%;min-width:0}`);